import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import axios from "axios";

export type FMap = {
	id: string;
	name: string;
	route: number[][][];
	// drawRoute: number[][],
	heights: number[][];
	userId: string;
};

export type ApiResponse<T=any> = {
	success: boolean,
	data: T,
	error: string,
}

function errorResponse(message:string):ApiResponse {
	return {
		success:false,
		data: {},
		error: message,
	}
}

function successResponse(data:any = {}):ApiResponse {
	return {
		success: true,
		data,
		error: "",
	}
}

const firebaseConfig = {
	apiKey: "AIzaSyDHpUVMf5wStweikOpoj9q9gk2wbnWszW4",
	authDomain: "digitalamidnattsloppet.firebaseapp.com",
	projectId: "digitalamidnattsloppet",
	storageBucket: "digitalamidnattsloppet.appspot.com",
	messagingSenderId: "425837514739",
	appId: "1:425837514739:web:668fb6a682bf61e940cc86",
	measurementId: "G-ZMZ0HZLWZ9"
};

export async function initFirebase(signInCallback):Promise<ApiResponse> {
	// Initialize Firebase
	firebase.initializeApp(firebaseConfig);
	firebase.analytics();

	firebase.auth().onAuthStateChanged(signInCallback);

	if(firebase.auth().isSignInWithEmailLink(window.location.href)) {
		try {
			const urlParams = new URLSearchParams(window.location.search);
			const result = await firebase.auth().signInWithEmailLink(urlParams.get("email") as string, window.location.href)
		}
		catch(error) {
			console.log("error", error);
			if(error.code == "auth/invalid-action-code") {
				return errorResponse("Inloggningslänken fungerade inte. Den kan vara felaktig eller redan använd.");
			} else {
				return errorResponse(`Något gick fel med inloggningslänken: ${error.message}`);
			}
		}
	}
	return successResponse();
}

export async function signIn(email:string, path:string):Promise<ApiResponse> {
	if(!path)
		path = "/";
	
	const actionCodeSettings = {
		url: `${window.location.origin}${path}?email=${encodeURIComponent(email)}`,
		handleCodeInApp: true,
	}
	try {
		await firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
		return successResponse();
	}	catch(error) {
		return errorResponse(`Ett fel har uppstått: ${error.message}`);
	}

}

export function signOut() {
	firebase.auth().signOut();
}

export async function loadMaps() : Promise<ApiResponse<FMap[]>> {
	const querySnapshot = await firebase.firestore().collection("maps").where("userId", "==", firebase.auth().currentUser?.uid).get();
	const maps = querySnapshot.docs.map(doc =>{
		const data = doc.data() as FMap;
		data.id = doc.id;
		return data;
	});
	return successResponse(maps);
}

export async function loadMap(mapId:string) : Promise<ApiResponse<FMap|undefined>> {
	try {
		const documentSnapshot = await firebase.firestore().collection("maps").doc(mapId).get();
		if (documentSnapshot.exists) {
			const map = documentSnapshot.data() as any;
			map.id = mapId;
			let route = JSON.parse(map.route as string);
			if(Array.isArray(route) && route.length > 0 && Array.isArray(route[0]) && Number.isFinite(route[0][0]))
				route = route.map(item => [item]);
			map.route = route;
			// map.drawRoute = JSON.parse(map.drawRoute || "" as string);
			map.heights = JSON.parse(map.heights as string);
			return successResponse(map as FMap);
		} else {
			return errorResponse("not_found");
		}
	} catch (error) {
		console.log(error);
		return errorResponse(""); //other message shown.
	}
}

export async function saveMap(map:FMap) : Promise<ApiResponse> {
	try {
		const token = await firebase.auth().currentUser?.getIdToken();
		await axios.post("/.netlify/functions/saveMap", { token, map })
		return successResponse();
	} catch (error) {
		const message = error.response.data.message;
		return errorResponse(message || "Kunde inte spara kartan.");
	}
}

export async function deleteMap(id:string) : Promise<ApiResponse> {
	try {
		const token = await firebase.auth().currentUser?.getIdToken();
		await axios.post("/.netlify/functions/deleteMap", { token, id })
		return successResponse();
	} catch (error) {
		const message = error.response.data.message;
		return errorResponse(message || "Kunde inte ta bort kartan.");
	}
}

export async function verifyId(id:string): Promise<ApiResponse<any>> {
	const token = await firebase.auth().currentUser?.getIdToken();
	const result = await axios.post("/.netlify/functions/verifyId", {token, id});
	return successResponse(result.data);
}


export async function loadAdminData(): Promise<ApiResponse<any>> {
	const token = await firebase.auth().currentUser?.getIdToken();
	const result = await axios.post("/.netlify/functions/admin", {token});
	return successResponse(result.data);
}